<section [formGroup]="loan.form" fxLayout="row" fxLayout.xs="column"
         fxLayoutGap="20px">

  <bb-number number="1"></bb-number>

  <div fxLayout="column" fxLayoutGap="20px">
    <h2 class="request-txt">BALIKBAYAD BRANCH</h2>
    <div class="subtle">Choose One</div>
    <mat-radio-group required formControlName="branch"
                     fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center"
                     fxLayout.xs="column" fxLayoutAlign.xs="start start">
      <mat-radio-button *ngFor="let branch of branches|async"
                        color="primary" [value]="branch.pk">
        {{branch.name}}
      </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="loan.form.get('branch').dirty && loan.form.get('branch').hasError('required')">Required.
    </mat-error>
  </div>
</section>
